import { IAppService } from '@modules/app/service/IAppService';
import { AppServiceFactory } from '@modules/app/service/AppServiceFactory';

import { Shortcut } from '../types';
import { IKeyMap } from './IKeyMap';

export class ReadOnlyKeyMap implements IKeyMap {
  private appSvc: IAppService;

  public constructor() {
    this.appSvc = AppServiceFactory.getInstance().createAppService();
  }

  handleKeyPress(shortcut: Shortcut): void {
    switch (shortcut.code) {
      case 'Escape': {
        this.appSvc.resetTool();
        break;
      }

      case 'KeyA': {
        if (shortcut.ctrl) {
          this.appSvc.selectAll();
        }
        break;
      }

      case 'KeyH': {
        this.appSvc.activateTool('pan');
        break;
      }

      case 'KeyV': {
        this.appSvc.activateTool('cursor');
        break;
      }

      default:
        break;
    }
  }
}
